// extracted by mini-css-extract-plugin
export var avatarContainer = "_d6-0";
export var gray = "_d6-f";
export var green = "_d6-c";
export var icon = "_d6-9";
export var image = "_d6-1";
export var lg = "_d6-6";
export var md = "_d6-5";
export var presenceDot = "_d6-b";
export var red = "_d6-d";
export var sm = "_d6-4";
export var status = "_d6-a";
export var xl = "_d6-7";
export var xs = "_d6-3";
export var xxl = "_d6-8";
export var xxs = "_d6-2";
export var yellow = "_d6-e";